import type { CheckboxProps } from '@ori-ui/mui';
import { styled, Checkbox } from '@ori-ui/mui';
import type { FC } from 'react';
import { memo } from 'react';

const StyledTermsAndConditions = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
  "terms-checkbox terms-text"
  `,
  gridTemplateColumns: 'auto 1fr',
  columnGap: theme.spacing(1),
  alignItems: 'center',
}));

const TermsAndConditionsComponent: FC<Pick<CheckboxProps, 'checked' | 'onChange'>> = ({
  children,
  checked,
  onChange,
}) => (
  <StyledTermsAndConditions>
    <Checkbox
      style={{ gridArea: 'terms-checkbox' }}
      checked={checked}
      color="primary"
      onChange={onChange}
    />
    <div style={{ gridArea: 'terms-text' }}>{children}</div>
  </StyledTermsAndConditions>
);

export const TermsAndConditions: FC<Pick<CheckboxProps, 'checked' | 'onChange'>> = memo(
  TermsAndConditionsComponent,
);

export default TermsAndConditions;
